import React from "react";

import { defaultSettings } from "./defaults/settings";
import Component from "./Component";
import Form from "./Form";

const createPlugin = (settings) => {
    const mergedSettings = { ...defaultSettings, ...settings };

    return {
        Component: (props) => <Component {...props} {...mergedSettings} />,
        FormComponent: (props) => <Form {...props} />,

        name: "indespension/content/hero",
        version: "1.0.0",
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            label: mergedSettings.defaultLabel,
            heroHeading: "",
            heroText: "",
            heroLink: "",
            heroButtonText: "",
            heroButtonColour: "primary",
            heroButtonLink: "",
            heroHeadingColour: "text-brand-black",
            backgroundType: "image",
            url: "",
            mobileUrl: "",
        }),
    };
};

export default createPlugin;
